import { FC, ReactElement } from 'react';
import DashboardDetailsMarketingHelpBlock from '../../components/DashboardDetailsMarketingHelpBlock/DashboardDetailsMarketingHelpBlock';
import { SCREENS } from '~/constants/screens';
import { appStore } from '~/mobx/appStore';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';

const DashboardDetailsMarketingHelp: FC = (): ReactElement => {
  return (
    <div className="dashboard-details-marketing-help">
      <DashboardDetailsMarketingHelpBlock
        path={SCREENS.PROMOCODE_CREATE()}
        linkTitle={localeStore.t('create_promocode')}
        description={localeStore.t('promocode_usage_tooltip')}
      />

      {appStore.isAddonsAvailable.cashback ? (
        <DashboardDetailsMarketingHelpBlock
          path={SCREENS.CASHBACK_CREATE()}
          linkTitle={localeStore.t('txt_create_cashback')}
          description={localeStore.t('cashback_usage_tooltip')}
        />
      ) : null}
    </div>
  );
};

export default DashboardDetailsMarketingHelp;
